module.exports = __webpack_public_path__ + "img/index-purple.26887ca7.svg";